(function () {
  if (customElements.get('product-gallery')) return; // avoid crashing if the name is taken

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.galleryReady) return;
      this.dataset.galleryReady = 'true';

      this.mainImg = this.querySelector('[data-gallery-main] img');
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const fullSrc = thumb.getAttribute('data-full-src');
          if (this.mainImg && fullSrc) {
            this.mainImg.removeAttribute('srcset');
            this.mainImg.src = fullSrc;
          }

          this.thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    }
  }

  customElements.define('product-gallery', ProductGallery);
})();